Namespace 'Monitoring.Reports.Publications.Content'

class Monitoring.Reports.Publications.Content.EmbeddedView extends Backbone.View

  className: 'content-section content-embedded'
  template: JST['backbone/templates/monitoring/reports/publications/content/embedded']

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    content = @options.contents[0]
    @$el.html(@template({ content_id: content.content_id }))
    eval("this.render_#{content.type}(content.content_id)")

  render_facebook: (post_id) ->
    view = new Monitoring.Previews.FacebookPostPreviewView({id: post_id})
    view.render()
    @$el.html(view.el)
    @trigger('rendered')

  render_twitter: (post_id) ->
    view = new Monitoring.Previews.TwitterTweetPreviewView({id: post_id})
    view.render()
    @$el.html(view.el)
    @trigger('rendered')
